import React from 'react';
import SectionCard from '../components/SectionCard';
import ProgressBar from '../components/ProgressBar';
import EngagementBox from '../components/EngagementBox';

export default function ObjectifSection({ avis_generes_revyo = 0, objectif_avis = 15, progression_pilote }) {
  const target = objectif_avis || 15;
  const value = avis_generes_revyo || 0;
  const percent = typeof progression_pilote === 'number'
    ? progression_pilote
    : Math.min(100, Math.round((value / target) * 100));

  return (
    <SectionCard title="🎯 Objectif pilote — 14 jours">
      <p style={styles.subtitle}>Générer {target} avis Google en 14 jours</p>
      <ProgressBar value={percent} />
      <p style={styles.progressLabel}>
        <strong style={styles.bold}>{value} / {target}</strong> avis générés via Revyo
      </p>

      <div style={styles.engagementGrid}>
        <EngagementBox
          variant="success"
          title="✅ Ce que Revyo fait pour vous"
          items={[
            'SMS auto aux clients satisfaits',
            'Retours privés recueillis',
            'Rapport hebdo par email',
            'Support humain réactif',
          ]}
        />
        <EngagementBox
          variant="warning"
          title="🤝 Ce qu'on vous demande"
          items={[
            'Poser le QR code sur les tables',
            "Mentionner Revyo à l'addition",
            'Configurer Google Maps',
            'Tester le funnel complet',
          ]}
        />
      </div>
    </SectionCard>
  );
}

const styles = {
  subtitle: {
    margin: 0,
    fontSize: 14,
    color: '#6B6B6B',
  },
  progressLabel: {
    margin: 0,
    fontSize: 13,
    color: '#6B6B6B',
  },
  bold: {
    color: '#1A1A1A',
    fontWeight: 700,
  },
  engagementGrid: {
    display: 'flex',
    flexDirection: 'column',
    gap: 10,
    marginTop: 4,
  },
};
